import { useSelector } from "react-redux";

import DataTable from "components/DataTable";
import Header from "components/Header";
import { routes } from "constants/routes";
import { PAYMENT_CONNECTED_BOARDING_HEADER } from "constants/user-settings";
import { getConnectedBrokerPaymentSpeedLabel } from "helpers/paymentSpeedLabel";
import useDeviceType from "hooks/useDeviceType";
import MainLayout from "layouts/Main";
import { IInvitedGroup } from "models/User";
import { RootState } from "store";
import InvitedGroupItem from "../../modules/Carrier/InvitedGroupItem";
import styles from "./style.module.scss";

export default function PaymentPreferences() {
  const { isDesktop } = useDeviceType();
  const { invitedGroups }: { invitedGroups: IInvitedGroup[] } = useSelector(
    (state: RootState) => state.userState
  );

  return invitedGroups ? (
    <MainLayout
      desktopTitle="Connections"
      customHeader={<Header label="Connections" goBackPath={routes.SETTINGS} isHideDesktop />}
      className={styles.paymentContainer}>
      <h3 className="mb-5 text-base mobile:text-sm mobile:mb-3">
        Contact the broker listed to update your payment preference
      </h3>

      {isDesktop ? (
        <DataTable
          headers={PAYMENT_CONNECTED_BOARDING_HEADER()}
          data={invitedGroups.map((data) => ({
            ...data,
            // HP-8422: resolved from this relationship's own payout_days rather than the broker's
            // default option, which made every connection read as the broker's fastest term.
            paymentSpeed: getConnectedBrokerPaymentSpeedLabel(
              data.payout_days,
              data.payment_speed_options
            )
          }))}
          sortDisableList={["group_data.tms_url"]}
        />
      ) : (
        <div className={styles.wrapper}>
          {invitedGroups.length ? (
            invitedGroups.map((item) => (
              <InvitedGroupItem key={item.id} type="connected" data={item} />
            ))
          ) : (
            <span className={styles.noData}>No Data Available</span>
          )}
        </div>
      )}
    </MainLayout>
  ) : null;
}
